// API base helper for public widget endpoints
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/public`;

export const publicApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Helpers
export const fmtMoney = (v) =>
  v == null ? "—" : `$${Math.round(v).toLocaleString("en-CA")}`;

export const fmtRate = (v) => (v == null ? "—" : `${Number(v).toFixed(2)}%`);

export const minutesAgo = (iso) => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  const diffMin = Math.max(0, Math.round((Date.now() - t) / 60000));
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin} min ago`;
  const hrs = Math.round(diffMin / 60);
  if (hrs < 24) return `${hrs} hr ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
};
